module.exports = __webpack_public_path__ + "740b8e9adcb998d4f65b3b18251fb5e2.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/public/fonts/Work_Sans/WorkSans-Regular.ttf
// module id = 1816
// module chunks = 1